import React, { useState } from 'react'
import PaginationComponent from '@/components/organisms/SectionCaseStudiesGrid/Pagination/PaginationComponent'
import { DropdownMenu } from '@/components/organisms/SectionCaseStudiesGrid/Dropdowns/Dropdowns'
import { CaseStudiesGridProps, SectionCaseStudiesGridItem } from '@/components/organisms/SectionCaseStudiesGrid/types'

export function Grid({
  items,
  items_per_page = '9',
  industry_label
}: { items: SectionCaseStudiesGridItem[] } & CaseStudiesGridProps) {
  const [activeCategory, setActiveCategory] = useState<string | undefined>('all')

  const categories = items?.flatMap((item) => item.content.industry)
  const categoriesMap = [...new Set(categories)]
  const filterItemsByCategory = (elements: SectionCaseStudiesGridItem[]) => {
    let filteredItems = elements

    // Apply category filter
    if (activeCategory?.toLowerCase() !== 'all') {
      if (activeCategory != null) {
        filteredItems = filteredItems.filter((item) => item.content.industry?.includes(activeCategory))
      }
    }

    return filteredItems
  }

  const filteredItems = filterItemsByCategory(items)

  return (
    <>
      <div className="flex flex-col w-full netbook:flex-row justify-between items-end py-24 gap-16 netbook:gap-24">
        <DropdownMenu
          categories={categoriesMap}
          activeCategory={activeCategory}
          setActiveCategory={setActiveCategory}
          industry_label={industry_label}
        />
      </div>
      <PaginationComponent items={filteredItems} itemsPerPage={+items_per_page} key={activeCategory} />
    </>
  )
}
